export enum OrderLineItemsTestComboBoxEnum {
  CHOOSE_STYLE_CB = 'choose-style-cb',
}

export enum OrderLineItemsTestTooltipEnum {
  LINE_ITEMS_LIMIT_TTP = 'line-items-limit-ttp',
}
